/**
 * Export service for downloading document data in various formats.
 */

import { authFetch } from './authService';

const API_BASE = `${import.meta.env.VITE_API_URL || 'http://localhost:8001'}/api/v1`;

function downloadFile(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function downloadJson(documentId: string): Promise<void> {
  try {
    const response = await authFetch(`${API_BASE}/export/json/${documentId}`);
    if (!response.ok) throw new Error('Export failed');
    const blob = await response.blob();
    downloadFile(blob, `export_${documentId}.json`);
  } catch (error) {
    console.error('Error downloading JSON:', error);
    throw error;
  }
}

export async function downloadCsv(documentId: string): Promise<void> {
  try {
    const response = await authFetch(`${API_BASE}/export/csv/${documentId}`);
    if (!response.ok) throw new Error('Export failed');
    const blob = await response.blob();
    downloadFile(blob, `export_${documentId}.csv`);
  } catch (error) {
    console.error('Error downloading CSV:', error);
    throw error;
  }
}

export async function downloadBulkJson(documentIds: string[]): Promise<void> {
  const response = await authFetch(`${API_BASE}/export/json/bulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ document_ids: documentIds }),
  });
  if (!response.ok) throw new Error('Export failed');
  const blob = await response.blob();
  downloadFile(blob, `export_bulk_${documentIds.length}_docs.json`);
}

export async function downloadBulkCsv(documentIds: string[]): Promise<void> {
  const response = await authFetch(`${API_BASE}/export/csv/bulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ document_ids: documentIds }),
  });
  if (!response.ok) throw new Error('Export failed');
  const blob = await response.blob();
  downloadFile(blob, `export_bulk_${documentIds.length}_docs.csv`);
}
